import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withKeys as _withKeys } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = {
  class: "bg-gray-50 shadow-lg rounded-sm mt-6",
  style: {
    "width": "1100px"
  }
};
const _hoisted_3 = {
  key: 1,
  class: "w-full bg-[rgba(var(--v-theme-error),0.08)] text-center text-base px-2 py-2 my-2 rounded-md",
  "data-cy": "invoice-warning"
};
const _hoisted_4 = {
  class: "no-print flex justify-end space-y-2 custom-disabled-button"
};
import { reactive, onMounted, onBeforeUnmount, ref, computed } from 'vue';
import Loader from '@/components/Loader.vue';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import InvoiceHeader from '@/modules/billing/review/editDraft/InvoiceHeader.vue';
import InvoiceContent from '@/modules/billing/review/editDraft/InvoiceContent.vue';
import InvoiceBalances from '@/modules/billing/review/editDraft/InvoiceBalances.vue';
import InvoiceButtons from '@/modules/billing/review/editDraft/InvoiceButtons.vue';
import InvoiceSubHeader from '@/modules/billing/review/editDraft/InvoiceSubHeader.vue';
import InvoiceUserInfo from '@/modules/billing/review/editDraft/InvoiceUserInfo.vue';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { createdInQuickbooks } from '@/modules/billing/review/invoiceUtils';
import RouteService from '@/services/RouteService';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import CreditLineItem from '@/modules/billing/review/editDraft/modals/CreditLineItem.vue';
import AdminFeesModal from '@/modules/billing/review/editDraft/modals/AdminFeesModal.vue';
import ExpenseLineItem from '@/modules/billing/review/editDraft/modals/ExpenseLineItem.vue';
import FixedFeeLineItem from '@/modules/billing/review/editDraft/modals/FixedFeeLineItem.vue';
import TimeEntryLineItem from '@/modules/billing/review/editDraft/modals/TimeEntryLineItem.vue';
import MemoModal from '@/modules/billing/review/editDraft/modals/MemoModal.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import NewTimeEntry from '@/modules/time/NewTimeEntry.vue';
import MatterChangeLineItem from '@/modules/billing/review/editDraft/modals/MatterChangeLineItem.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { storeToRefs } from 'pinia';
export default {
  __name: 'MainDraftEditModal',
  props: {
    tracking: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    entryEditService: {
      type: Object,
      required: true
    },
    snippetService: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const modalRef = ref(null);
    const unsavedChangesDialog = ref(null);

    // Unique component instance ID to ensure proper container cleanup
    const componentId = ref(Date.now());
    const draftModalState = reactive({
      headerText: 'Loading',
      loading: true,
      invoiceWarning: false,
      isSaving: false,
      url: '',
      hideDetail: false,
      // we can sent these to pinia if we want to
      showMemoModal: false,
      openUnsavedChangesDialog: false
      // we can sent these to pinia if we want to
    });

    // Modal instance counters to force fresh component creation
    const modalCounters = reactive({
      newTimeEntry: 0,
      newExpense: 0,
      newFixedFee: 0,
      editExpense: 0,
      editTimeEntry: 0,
      editFixedFee: 0,
      editCredit: 0,
      editAdmin: 0,
      memo: 0,
      matterChange: 0
    });
    const invoiceEditorStore = useInvoiceEditorStore();
    const invoiceState = useInvoiceState();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    const routeService = new RouteService(props);
    const {
      permissions,
      features
    } = storeToRefs(useMeStore());
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const {
      getIsLocked
    } = useInvoiceState();
    const {
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const meStore = useMeStore();
    const companyStore = useCompanyStore();
    const {
      addAdjustmentGroup
    } = invoiceState;
    onMounted(async () => {
      modalRef.value.focus();
      draftModalState.loading = true;
      try {
        draftModalState.loading = true;
        await invoiceState.getInvoiceContent({
          id: props.stateParams.invoiceId
        });

        // Force refresh both stores to ensure we have the latest demo mode settings
        // until we remove angular user service
        await Promise.all([meStore.getMe(true),
        // Force refresh me store
        companyStore.loadMyCompany(true) // Force refresh company store
        ]);
        initializeModalState();
        draftModalState.loading = false;
      } catch (error) {
        handleError(error);
      }
    });
    onBeforeUnmount(() => {
      // Reset all modal states to ensure clean unmounting
      invoiceEditorStore.resetModalStates();
      draftModalState.showMemoModal = false;
      draftModalState.openUnsavedChangesDialog = false;
    });
    const initializeModalState = async () => {
      invoiceEditorStore.setViewInvoice(props.stateParams.invoiceState, permissions);
      if (companySettings.value.invoice) {
        invoiceState.setFormat(companySettings.value.invoice);
      }
      if (companySettings.value.trustEnabled) {
        invoiceState.setConfig(companySettings.value.trust?.trustConfig);
      }

      // Setting off: every draft fee is assignable and none warns (BR-024) -- the store's
      // defaults already -- so there is nothing to fetch. Nor on an invoice this user can't edit:
      // the warning is about what generating it will do. Runs after getInvoiceContent, whose
      // $reset would otherwise clear the result, and after setViewInvoice above.
      if (companySettings.value.keepTimeUnlockedAfterBilling === true && !(onlyViewInvoice.value || invoiceState.getIsLocked)) {
        invoiceState.getFeeStates({
          id: props.stateParams.invoiceId
        });
      }
      getSetInvoiceWarningAndHeaders();
    };
    const getSetInvoiceWarningAndHeaders = () => {
      draftModalState.invoice = invoiceState;
      const {
        state
      } = invoiceState;
      draftModalState.invoiceWarning = getInvoiceWarning(draftModalState.invoice);
      draftModalState.headerText = invoiceEditorStore.setInvoiceHeaderText(state);
      draftModalState.hideDetail = determineIfDetailsShouldBeHidden(invoiceState);
    };
    const determineIfDetailsShouldBeHidden = invoice => {
      if (!(invoice.state.open || invoice.state.closed)) return false;
      return createdInQuickbooks(invoice) || hasAmountMismatch(invoice);
    };
    const hasAmountMismatch = invoice => {
      return !!(invoice.totals && invoice.totals.originalAmount);
    };
    const getInvoiceWarning = invoice => {
      if (invoice.state.open || invoice.state.closed) {
        draftModalState.url = `${props.leanLawAuth.domain}/v1/invoices/${invoice.id}/pdf`;
        const hasQuickBooksId = !!invoice.accounting?.id;
        if (!hasQuickBooksId) {
          return "The invoice doesn't exist in this QuickBooks account (probably because you changed QuickBooks account at some point).";
        }
        if (createdInQuickbooks(invoice)) {
          return 'This invoice was not created in LeanLaw. To see invoice line item detail, open it in QuickBooks.';
        } else if (hasAmountMismatch(invoice)) {
          return "The invoice was edited in QuickBooks. Select 'Open in QuickBooks' or 'Print Preview' to see the detail.";
        } else {
          return 'This invoice was submitted to QuickBooks and can no longer be changed- revert it back to draft to make changes.';
        }
      }
      if (invoice.state.approved) {
        return 'Invoice cannot be changed once approved. To change it, send it back to draft.';
      }
      if (!permissions.value.billing.edit) {
        return 'Invoice is locked because your role does not have permissions to edit draft invoices';
      }
      return false;
    };
    const rejectInvoice = async () => {
      if (invoiceState.getHasInvoiceChanged) {
        draftModalState.openUnsavedChangesDialog = true;
        unsavedChangesDialog.value.open();
      }
      handleCloseButton();
    };

    // Check if any nested modal is currently open
    const hasOpenNestedModal = () => {
      return invoiceEditorStore.showNewFixedFeeModal || invoiceEditorStore.showEditFixedFeeLineItemModal || invoiceEditorStore.showEditExpenseLineItemModal || invoiceEditorStore.showNewExpenseModal || invoiceEditorStore.showEditEntryLineItemModal || invoiceEditorStore.showNewTimeEntryModal || invoiceEditorStore.showEditCreditLineItemModal || invoiceEditorStore.showEditAdminLineItemModal || invoiceEditorStore.showMatterChangeModal || draftModalState.showMemoModal || draftModalState.openUnsavedChangesDialog;
    };
    const handleEscKey = event => {
      // Only close parent modal if no nested modals are open
      // If a nested modal is open, let Vuetify handle closing it
      if (!hasOpenNestedModal()) {
        handleCloseButton();
      }
    };
    const handleCloseButton = (reload = false) => {
      // Reset all modal states before closing to prevent state leakage to next invoice
      invoiceEditorStore.resetModalStates();
      draftModalState.showMemoModal = false;
      draftModalState.openUnsavedChangesDialog = false;
      if (reload) {
        props.rootScope.reload();
      }
      routeService.go('^');
    };
    const showAddCreditButton = computed(() => {
      return !(onlyViewInvoice.value || getIsLocked.value || invoiceState.hasCredit);
    });

    // add credit
    const addAdjustmentGroupItem = () => {
      const adjustmentLineItem = addAdjustmentGroup();
      invoiceEditorStore.editLineItem(adjustmentLineItem);
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createElementBlock("div", {
        id: `draft-modal-container-${componentId.value}`,
        tabindex: "0",
        class: "fixed inset-0 z-[200] flex items-center justify-center overflow-auto vue-modal-background tw at-update-rate-group",
        style: {
          "z-index": "100"
        },
        onKeydown: _withKeys(handleEscKey, ["esc"]),
        ref_key: "modalRef",
        ref: modalRef
      }, [_createElementVNode("div", _hoisted_2, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), draftModalState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Invoice',
        class: "my-16 px-6"
      })) : (_openBlock(), _createBlock(_component_v_card, {
        key: 1,
        title: draftModalState.headerText
      }, {
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => handleCloseButton())
        }, {
          default: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(LlConfirmationDialog, {
          ref_key: "unsavedChangesDialog",
          ref: unsavedChangesDialog,
          title: "You've updated entries",
          message: "You've made changes to entries or expenses in this invoice.\n                    To keep these changes you must save the invoice. Otherwise,\n                      you must discard your edits to the time entries.",
          toggleText: "Discard changes",
          confirmText: "Save invoice",
          persistent: "",
          onConfirm: _cache[1] || (_cache[1] = $event => {
            draftModalState.openUnsavedChangesDialog = false;
            handleCloseButton();
          }),
          onCancel: _cache[2] || (_cache[2] = $event => draftModalState.openUnsavedChangesDialog = false)
        }, null, 512), (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: _unref(invoiceEditorStore).showNewFixedFeeModal,
          "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => _unref(invoiceEditorStore).showNewFixedFeeModal = $event), _cache[5] || (_cache[5] = val => val && modalCounters.newFixedFee++)],
          width: "600",
          attach: `#draft-modal-container-${componentId.value}`,
          scrim: "false",
          key: `new-fixed-fee-${modalCounters.newFixedFee}`
        }, {
          default: _withCtx(() => [_createVNode(FixedFeeLineItem, {
            isNewFixedFee: true,
            tracking: __props.tracking,
            onCancel: _cache[3] || (_cache[3] = $event => _unref(invoiceEditorStore).cancelAddLineItem())
          }, null, 8, ["tracking"])]),
          _: 1
        }, 8, ["modelValue", "attach"])), (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: _unref(invoiceEditorStore).showEditFixedFeeLineItemModal,
          "onUpdate:modelValue": [_cache[7] || (_cache[7] = $event => _unref(invoiceEditorStore).showEditFixedFeeLineItemModal = $event), _cache[8] || (_cache[8] = val => val && modalCounters.editFixedFee++)],
          width: "600",
          attach: `#draft-modal-container-${componentId.value}`,
          scrim: "false",
          key: `edit-fixed-fee-${modalCounters.editFixedFee}`
        }, {
          default: _withCtx(() => [_createVNode(FixedFeeLineItem, {
            tracking: __props.tracking,
            onCancel: _cache[6] || (_cache[6] = $event => _unref(invoiceEditorStore).showEditFixedFeeLineItemModal = false)
          }, null, 8, ["tracking"])]),
          _: 1
        }, 8, ["modelValue", "attach"])), (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: _unref(invoiceEditorStore).showEditExpenseLineItemModal,
          "onUpdate:modelValue": [_cache[10] || (_cache[10] = $event => _unref(invoiceEditorStore).showEditExpenseLineItemModal = $event), _cache[11] || (_cache[11] = val => val && modalCounters.editExpense++)],
          width: "800",
          attach: `#draft-modal-container-${componentId.value}`,
          scrim: "false",
          key: `edit-expense-${modalCounters.editExpense}`
        }, {
          default: _withCtx(() => [_createVNode(ExpenseLineItem, {
            onCancel: _cache[9] || (_cache[9] = $event => _unref(invoiceEditorStore).showEditExpenseLineItemModal = false)
          })]),
          _: 1
        }, 8, ["modelValue", "attach"])), (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: _unref(invoiceEditorStore).showNewExpenseModal,
          "onUpdate:modelValue": [_cache[13] || (_cache[13] = $event => _unref(invoiceEditorStore).showNewExpenseModal = $event), _cache[14] || (_cache[14] = val => val && modalCounters.newExpense++)],
          width: "600",
          attach: `#draft-modal-container-${componentId.value}`,
          scrim: "false",
          key: `new-expense-${modalCounters.newExpense}`
        }, {
          default: _withCtx(() => [_createVNode(ExpenseLineItem, {
            isNewExpense: true,
            onCancel: _cache[12] || (_cache[12] = $event => _unref(invoiceEditorStore).cancelAddLineItem())
          })]),
          _: 1
        }, 8, ["modelValue", "attach"])), (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: _unref(invoiceEditorStore).showEditEntryLineItemModal,
          "onUpdate:modelValue": [_cache[16] || (_cache[16] = $event => _unref(invoiceEditorStore).showEditEntryLineItemModal = $event), _cache[17] || (_cache[17] = val => val && modalCounters.editTimeEntry++)],
          width: "800",
          attach: `#draft-modal-container-${componentId.value}`,
          scrim: "false",
          key: `edit-time-entry-${modalCounters.editTimeEntry}`
        }, {
          default: _withCtx(() => [_createVNode(TimeEntryLineItem, {
            onCancel: _cache[15] || (_cache[15] = $event => _unref(invoiceEditorStore).showEditEntryLineItemModal = false)
          })]),
          _: 1
        }, 8, ["modelValue", "attach"])), (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: _unref(invoiceEditorStore).showNewTimeEntryModal,
          "onUpdate:modelValue": [_cache[19] || (_cache[19] = $event => _unref(invoiceEditorStore).showNewTimeEntryModal = $event), _cache[20] || (_cache[20] = val => val && modalCounters.newTimeEntry++)],
          width: "800",
          attach: `#draft-modal-container-${componentId.value}`,
          scrim: "false",
          key: `new-time-entry-${modalCounters.newTimeEntry}`
        }, {
          default: _withCtx(() => [_createVNode(NewTimeEntry, {
            entryEditService: props.entryEditService,
            snippetService: props.snippetService,
            onCancel: _cache[18] || (_cache[18] = $event => _unref(invoiceEditorStore).cancelAddLineItem())
          }, null, 8, ["entryEditService", "snippetService"])]),
          _: 1
        }, 8, ["modelValue", "attach"])), (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: _unref(invoiceEditorStore).showEditCreditLineItemModal,
          "onUpdate:modelValue": [_cache[22] || (_cache[22] = $event => _unref(invoiceEditorStore).showEditCreditLineItemModal = $event), _cache[23] || (_cache[23] = val => val && modalCounters.editCredit++)],
          width: "600",
          attach: `#draft-modal-container-${componentId.value}`,
          scrim: "false",
          key: `edit-credit-${modalCounters.editCredit}`
        }, {
          default: _withCtx(() => [_createVNode(CreditLineItem, {
            onCancel: _cache[21] || (_cache[21] = $event => _unref(invoiceEditorStore).showEditCreditLineItemModal = false)
          })]),
          _: 1
        }, 8, ["modelValue", "attach"])), (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: _unref(invoiceEditorStore).showEditAdminLineItemModal,
          "onUpdate:modelValue": [_cache[26] || (_cache[26] = $event => _unref(invoiceEditorStore).showEditAdminLineItemModal = $event), _cache[27] || (_cache[27] = val => val && modalCounters.editAdmin++)],
          width: "600",
          attach: `#draft-modal-container-${componentId.value}`,
          scrim: "false",
          key: `edit-admin-fee-${modalCounters.editAdmin}`
        }, {
          default: _withCtx(() => [_createVNode(AdminFeesModal, {
            onClose: _cache[24] || (_cache[24] = $event => _unref(invoiceEditorStore).showEditAdminLineItemModal = false),
            onRemove: _cache[25] || (_cache[25] = $event => _unref(invoiceEditorStore).showEditAdminLineItemModal = false)
          })]),
          _: 1
        }, 8, ["modelValue", "attach"])), (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: draftModalState.showMemoModal,
          "onUpdate:modelValue": [_cache[29] || (_cache[29] = $event => draftModalState.showMemoModal = $event), _cache[30] || (_cache[30] = val => val && modalCounters.memo++)],
          width: "600",
          attach: `#draft-modal-container-${componentId.value}`,
          scrim: "false",
          key: `memo-${modalCounters.memo}`
        }, {
          default: _withCtx(() => [_createVNode(MemoModal, {
            onCancel: _cache[28] || (_cache[28] = $event => draftModalState.showMemoModal = false)
          })]),
          _: 1
        }, 8, ["modelValue", "attach"])), (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: _unref(invoiceEditorStore).showMatterChangeModal,
          "onUpdate:modelValue": [_cache[32] || (_cache[32] = $event => _unref(invoiceEditorStore).showMatterChangeModal = $event), _cache[33] || (_cache[33] = val => val && modalCounters.matterChange++)],
          width: "600",
          attach: `#draft-modal-container-${componentId.value}`,
          scrim: "false",
          key: `matter-change-${modalCounters.matterChange}`
        }, {
          default: _withCtx(() => [_createVNode(MatterChangeLineItem, {
            onCancel: _cache[31] || (_cache[31] = $event => _unref(invoiceEditorStore).showMatterChangeModal = false)
          })]),
          _: 1
        }, 8, ["modelValue", "attach"])), _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createVNode(_component_v_container, {
            style: {
              "height": "auto",
              "max-width": "100%",
              "max-height": "90vh",
              "overflow-y": "auto",
              "padding-bottom": "5rem"
            }
          }, {
            default: _withCtx(() => [_unref(companySettings).workflow?.reviewer ? (_openBlock(), _createBlock(InvoiceUserInfo, {
              key: 0
            })) : _createCommentVNode("", true), draftModalState.invoiceWarning ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(draftModalState.invoiceWarning), 1)) : _createCommentVNode("", true), _createVNode(InvoiceBalances, {
              tracking: __props.tracking
            }, null, 8, ["tracking"]), _createVNode(InvoiceHeader), _createVNode(InvoiceSubHeader, {
              draftModalState: draftModalState
            }, null, 8, ["draftModalState"]), _createVNode(InvoiceContent, {
              hideDetail: draftModalState.hideDetail,
              tracking: __props.tracking
            }, null, 8, ["hideDetail", "tracking"]), _createElementVNode("div", _hoisted_4, [showAddCreditButton.value ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              onBtnClick: _cache[34] || (_cache[34] = $event => addAdjustmentGroupItem()),
              "data-cy": "add-credit-button-draft"
            }, {
              default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode(" Add Credit ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]), _createVNode(InvoiceBalances, {
              tracking: __props.tracking
            }, null, 8, ["tracking"])]),
            _: 1
          }), _createVNode(InvoiceButtons, {
            rootScope: __props.rootScope,
            leanLawAuth: __props.leanLawAuth,
            url: draftModalState.url,
            leanLawApi: __props.leanLawApi,
            tracking: __props.tracking,
            routerService: _unref(routeService),
            onRejectInvoice: rejectInvoice,
            onCancel: handleCloseButton
          }, null, 8, ["rootScope", "leanLawAuth", "url", "leanLawApi", "tracking", "routerService"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["title"]))])], 40, _hoisted_1);
    };
  }
};